$(document).ready(function() {
  if ($('.page-productDetails').length === 0) {
    $('.add_to_cart_form').show();
  }
});

ACC.product = {
  initQuickviewLightbox: function() {
    this.enableAddToCartButton();
    this.bindToAddToCartForm();
  },

  enableAddToCartButton: function() {
    $('#addToCartButton').removeAttr('disabled');
  },

  addTocartFormValidation: function($addToCartForm) {
    $addToCartForm.validate({
      rules: {
        qty: {
          required: true,
          min: 1,
          digits: true
        }
      }
    });
  },

  bindToAddToCartForm: function() {
    var $addToCartForm = $('.add_to_cart_form');

    if ($addToCartForm.length > 0) {
      $addToCartForm.ajaxForm({
        success: ACC.product.displayAddToCartPopup(),
        error: $.colorbox.close()
      });
    }
  },

  displayAddToCartPopup: function(cartResult, statusText, xhr, formElement) {
  /* eslint-disable xss/no-mixed-html*/
    ACC.common.$globalMessages.html(cartResult.cartGlobalMessagesHtml);

    $('#addToCartLayer').remove(); /* eslint-enable xss/no-mixed-html*/

    if (typeof ACC.minicart.refreshMiniCartCount === 'function') {
      ACC.minicart.refreshMiniCartCount();
    }

    $('#header').append(cartResult.addToCartLayer);

    $('#addToCartLayer').fadeIn(function() {
      $.colorbox.close();

      /* eslint-disable vars-on-top*/
      var timeoutId = setTimeout(function() {
        $('#addToCartLayer').fadeOut(function() {
          $('#addToCartLayer').remove();
        });
      }, 5000);

      if (typeof timeoutId !== 'undefined') {
        clearTimeout(timeoutId);
      }
    });


    var productCode = $('[name=productCodePost]', formElement).val(),
        quantityField = $('[name=qty]', formElement).val(),
        quantity = 1;


    /* eslint-disable no-undefined*/
    if (quantityField !== undefined) {
      quantity = quantityField;
      /* eslint-enable no-undefined*/
    }

    ACC.track.trackAddToCart(productCode, quantity, cartResult.cartData);

    // If it is orderForm, disable add to cart button in the end
    if ($('#orderFormAddToCart').length > 0) {
      $('#addToCartBtn').attr('disabled', 'disabled');
    }
  },
  playpause: function(currentVideo) {
    var pauseIcon = 'ph-icon-pause',
        playButton = 'ph-icon-play-button',
        playIconDetail = 'ph-product__playIconDetailImage';

    if (currentVideo[0].paused || currentVideo[0].ended) {
      $(currentVideo[0]).parents('.ph-video').find('.' + playIconDetail).addClass(pauseIcon).removeClass(playButton);
      currentVideo[0].play();
    } else {
      $(currentVideo[0]).parents('.ph-video').find('.' + playIconDetail).removeClass(pauseIcon).addClass(playButton);
      currentVideo[0].pause();
    }
  },

  updatebar: function(pagex, currentVideo) {
    var progress = $(currentVideo[0]).parents('.ph-video').find('.ph-video__progress');

    /* Calculate drag position
     and update video currenttime
     as well as progress bar */
    var maxduration = currentVideo[0].duration,
        position = pagex - progress.offset().left,
        percentage = 100 * position / progress.width();

    if (percentage > 100) {
      percentage = 100;
    }

    if (percentage < 0) {
      percentage = 0;
    }

    $(currentVideo[0]).parents('.ph-video').find('.ph-video__timebar').css('width', percentage + '%');
    currentVideo[0].currentTime = maxduration * percentage / 100;
  },

  timeFormat: function(seconds) {
    var minutes = Math.floor(seconds / 60),
        sec = 0;

    if (Math.floor(seconds - (minutes * 60)) < 10) {
      sec = '0' + Math.floor(seconds - (minutes * 60));
    } else {
      sec = Math.floor(seconds - (minutes * 60));
    }

    if (Math.floor(seconds / 60) < 10) {
      minutes = '0' + Math.floor(seconds / 60);
    } else {
      minutes = Math.floor(seconds / 60);
    }

    return minutes + ':' + sec;
  },

  enterFullscreen: function($videoElement) {
    if ($videoElement[0].requestFullscreen) {
      $videoElement[0].requestFullscreen();
    } else if ($videoElement[0].webkitRequestFullscreen) {
      $videoElement[0].webkitRequestFullscreen();
    } else if ($videoElement[0].mozRequestFullScreen) {
      $videoElement[0].mozRequestFullScreen();
    } else if ($videoElement[0].msRequestFullscreen) {
      $videoElement[0].msRequestFullscreen();
    }
  },
  exitFullscreen: function() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  },
  updateVolume: function(pagex, vol, currentVideo) {
    var volume = $(currentVideo[0]).parents('.ph-video').find('.ph-video__volume'),
        percentage = 0;

    /* If only volume have specificed
   then direct update volume */
    if (vol) {
      percentage = vol * 100;
    } else {
      var position = pagex - volume.offset().left;

      percentage = 100 * position / volume.width();
    }

    if (percentage > 100) {
      percentage = 100;
    }

    if (percentage < 0) {
      percentage = 0;
    }

    // Update volume bar and video volume
    $('.ph-video__volumebar').css('width', percentage + '%');
    currentVideo[0].volume = percentage / 100;

    // Change sound icon based on volume
    var $videoSound = $('.ph-video__sound');
    var videoSound = 'ph-video__sound2';
    var volumeMute = 'ph-icon-volume-mute';

    if (currentVideo[0].volume === 0 || currentVideo[0].volume <= 0.007) {
      $videoSound.removeClass(videoSound).addClass(volumeMute);
    } else if (currentVideo[0].volume > 0.5) {
      $videoSound.removeClass(volumeMute).addClass(videoSound);
    } else {
      $videoSound.removeClass(volumeMute).removeClass(videoSound);
    }
  }
};

$(document).ready(function() {
  /* eslint-disable no-with*/
  with (ACC.product) {
  /* eslint-enable no-with*/
  /* eslint-disable no-undef*/
    bindToAddToCartForm();
    enableAddToCartButton();
  /* eslint-enable no-undef*/
  }

  $('.ph-product__playIconDetailImage').on('click', function() {
    var vidplay = 'product__videoplay';
    var currentVideo = $(this).parents('.ph-video').find('.ph-' + vidplay);

    ACC.product.playpause(currentVideo);
  });
});

$(document).ready(function() {
  $('.ph-switchscreen').on('click', function() {
    var agentId = (/iPad|iPhone|iPod/).test(navigator.userAgent) && !window.MSStream;
    var $videoElement = '';
    var videofullscreen = 'ph-icon-fullscreen';

    if (agentId) {
      $videoElement = $(this).parents('.ph-video').find('.ph-product__videoplay');
    } else {
      $videoElement = $(this).parents('.ph-video').find('.ph-video-overlay');
    }

    if ($(this).hasClass(videofullscreen)) {
      if (!agentId) {
        $videoElement.parents('.ph-video').find('.ph-video__enlarge').children().removeClass(videofullscreen).addClass('ph-icon-exit-fullscreen');
      }

      ACC.product.enterFullscreen($videoElement);
    } else {
      if (!agentId) {
        $videoElement.parents('.ph-video').find('.ph-video__enlarge').children().removeClass('ph-icon-exit-fullscreen').addClass(videofullscreen);
      }

      ACC.product.exitFullscreen();

      $('.ph-video-icons-section').show();
    }
  });
});
$(document).ready(function() {
  var $video = $('.ph-product__videoplay'),
      $videoVolume = $('.ph-video__volume'),
      $videoProgress = $('.ph-video__progress'),
      timeDrag = false,
      volumeDrag = false,
      videoPlayElmt = 'ph-product__videoplay',
      videoicnmute = 'ph-icon-volume-mute',
      disableButton = 'ph-disable-button';

  $('.ph-next-stage, .ph-prev-stage, .thumb').on('click', function() {
    var prodvideo = 'ph-product__videoplay';

    $('.' + prodvideo).each(function() {
      $(this)[0].pause();
      $(this)[0].muted = false;
      $(this).parents('.ph-video').find('.ph-video__sound').removeClass(videoicnmute);
      $(this).parents('.ph-video').find('.ph-product__playIconDetailImage').removeClass('ph-icon-pause').addClass('ph-icon-play-button');

      ACC.product.updateVolume(0, 0.7, $(this));
    });
  });

  $video.on('loadedmetadata', function() {
    var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);

    // Set video properties
    $('.ph-video__currenttime').text(ACC.product.timeFormat(0));
    $('.ph-video__duration').text(ACC.product.timeFormat(currentVideo[0].duration));
    ACC.product.updateVolume(0, 0.7, currentVideo);
  });

  $videoVolume.on('mousedown', function(event) {
    var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);
    var visound = 'video__sound';

    volumeDrag = true;
    currentVideo[0].muted = false;
    $('.ph-' + visound).removeClass(videoicnmute);
    ACC.product.updateVolume(event.pageX, null, currentVideo);
  });

  $videoVolume.on('mouseup', function(event) {
    if (volumeDrag) {
      var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);

      volumeDrag = false;
      ACC.product.updateVolume(event.pageX, null, currentVideo);
    }
  });

  $videoVolume.on('mousemove', function(event) {
    if (volumeDrag) {
      var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);

      ACC.product.updateVolume(event.pageX, null, currentVideo);
    }
  });

  $videoProgress.on('mousedown', function(event) {
    var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);

    timeDrag = true;
    ACC.product.updatebar(event.pageX, currentVideo);
  });
  $videoProgress.on('mouseup', function(event) {
    if (timeDrag) {
      var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);

      timeDrag = false;
      ACC.product.updatebar(event.pageX, currentVideo);
    }
  });
  $videoProgress.on('mousemove', function(event) {
    if (timeDrag) {
      var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt);

      ACC.product.updatebar(event.pageX, currentVideo);
    }
  });


  $video.on('timeupdate', function() {
    var currentVideo = $(this).parents('.ph-video').find('.' + videoPlayElmt),
        currentPos = currentVideo[0].currentTime,
        maxduration = currentVideo[0].duration,
        perc = 100 * currentPos / maxduration,
        pausebut = 'icon-pause',
        playbut = 'icon-play-button',
        playdeticon = 'product__playIconDetailImage';

    $(this).parents('.ph-video').find('.ph-video__timebar').css('width', perc + '%');
    $(this).parents('.ph-video').find('.ph-video__currenttime').text(ACC.product.timeFormat(currentPos));

    if (maxduration === currentPos) {
      $(this).parents('.ph-video').find('.ph-' + playdeticon).removeClass('ph-' + pausebut).addClass('ph-' + playbut);
    }
  });

  if ($('.template-pages-product-productLayout2Page').length > 0) {
  // Hiding Loader Gif
    setTimeout(function() {
      $('.hide-video-loader').hide();
    }, 2000);
  }

  if ($('.ph-sap-orderBlock').length > 0) {
    $('.ph-addToCartButton').addClass(disableButton).attr('disabled', 'disabled');
    $('.ph-notifyme-button').addClass(disableButton);
    $('.ph-notify-sec').addClass(disableButton);
    $('.ph-merch-sendReq').addClass(disableButton);
    $('.ph-cart').addClass('ph-cart-disable');
  }

  $('.ph-decisionpage__item:visible').each(function(index, item) {
    var prodCode = $(item).attr('id').split('ph-pl-row-'),
        $productElement = $('#ph-pl-row-' + prodCode[1]),

        validProdClsval = $productElement.find('.ph-validProductCls').val();

    if (validProdClsval === 'false') {
      $productElement.find('.ph-cart').addClass(disableButton);
      $productElement.find('.addToCartButton').addClass(disableButton).attr('disabled', 'disabled');
    }
  });
});

/* eslint-enable vars-on-top*/
